class SomaFreeGiftController {
  constructor(config) {
    this.config = config;
    this.busy = false;
    this.queued = false;
    this.timer = null;
  }

  start() {
    document.addEventListener("cart:updated", () => this.schedule());
    document.addEventListener("product-ajax:added", () => this.schedule());

    if (window.FoxThemeEvents && window.PUB_SUB_EVENTS) {
      window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, (state) => {
        if (state?.source !== "soma-free-gift") this.schedule();
      });
    }

    this.schedule(0);
  }

  schedule(delay = 100) {
    window.clearTimeout(this.timer);
    this.timer = window.setTimeout(() => this.sync(), delay);
  }

  async sync() {
    if (this.busy) {
      this.queued = true;
      return;
    }

    this.busy = true;

    try {
      const cart = await this.getCart();
      const giftLines = cart.items.filter(
        (item) => String(item.variant_id) === String(this.config.variantId)
      );
      const paidSubtotal = cart.items
        .filter((item) => String(item.variant_id) !== String(this.config.variantId))
        .reduce((total, item) => total + item.final_line_price, 0);
      const qualifies = paidSubtotal >= this.config.threshold;

      if (qualifies && giftLines.length === 0) {
        const response = await this.request(FoxThemeSettings.routes.cart_add_url, {
          items: [
            {
              id: Number(this.config.variantId),
              quantity: 1,
              properties: { _soma_free_gift: "cc-cream-5ml" },
            },
          ],
        });
        await this.render(response.sections);
        return;
      }

      const updates = {};

      giftLines.forEach((line, index) => {
        if (!qualifies || index > 0) {
          updates[line.key] = 0;
        } else if (line.quantity !== 1) {
          updates[line.key] = 1;
        }
      });

      if (Object.keys(updates).length > 0) {
        const response = await this.request(FoxThemeSettings.routes.cart_update_url, { updates });
        await this.render(response.sections);
      }
    } catch (error) {
      console.error("Soma free gift error", error);
    } finally {
      this.busy = false;

      if (this.queued) {
        this.queued = false;
        this.schedule(0);
      }
    }
  }

  getSections() {
    const sections = new Set();
    const cartDrawer = document.querySelector("cart-drawer");
    const mainCart = document.querySelector("cart-items");

    if (cartDrawer?.getSectionsToRender) {
      cartDrawer.getSectionsToRender(true).forEach((section) => sections.add(section.id));
    }

    if (mainCart?.getSectionsToRender) {
      mainCart.getSectionsToRender().forEach((section) => sections.add(section.section));
    }

    return Array.from(sections);
  }

  async getCart() {
    const response = await fetch(`${FoxThemeSettings.routes.cart}.js`, {
      headers: { Accept: "application/json" },
    });

    if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
    return response.json();
  }

  async request(url, body) {
    const sections = this.getSections();

    if (sections.length > 0) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(body),
    });

    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || response.statusText);
    return data;
  }

  async render(sections = {}) {
    const cart = await this.getCart();
    cart.sections = sections || {};
    cart.source = "soma-free-gift";

    if (window.FoxThemeSettings?.template === "cart") {
      window.location.reload();
      return;
    }

    const cartDrawer = document.querySelector("cart-drawer");
    const keepDrawerOpen = cartDrawer?.drawer?.isOpen?.() === true;

    if (window.FoxThemeEvents && window.PUB_SUB_EVENTS) {
      window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, cart);
    }

    document.dispatchEvent(
      new CustomEvent("cart:updated", {
        detail: { cart, source: "soma-free-gift" },
      })
    );

    if (cartDrawer) {
      document.dispatchEvent(
        new CustomEvent("cart:refresh", {
          detail: { open: keepDrawerOpen },
        })
      );
    }
  }
}

const somaFreeGiftConfig = window.FoxThemeSettings?.freeGift;

if (somaFreeGiftConfig?.enabled && somaFreeGiftConfig.variantId) {
  const somaFreeGiftController = new SomaFreeGiftController(somaFreeGiftConfig);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => somaFreeGiftController.start(), { once: true });
  } else {
    somaFreeGiftController.start();
  }
}
